/** Convierte una opción al formato `labelInValue`. */
export const optionToLabelInValueFormat = (option) => {
	return {
		label: option.label,
		value: option.value,
		key: option.value,
		disabled: option.disabled,
		title: option.title,
	};
};

const removeAccents = (str) => {
	return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export const defaultFilterOption = (inputValue, option) => {
	const searchValue = removeAccents(inputValue.toLowerCase());
	const optionLabel = removeAccents(String(option?.label ?? '').toLowerCase());
	return optionLabel.includes(searchValue);
};